<script>
import svgList from '../assets/svg-list';

export default {
  name: 'app-icon',
  props: {
    src: String,
    name: String,
    width: String,
    height: String,
    viewBox: String,
    type: {
      type: String,
      required: true,
      validator(value) {
        return ['img', 'svg', 'font'].includes(value);
      }
    }
  },
  computed: {
    svg() {
      return svgList[this.name] || {};
    },
    imageSrc() {
      // for type 'img' we pass in the name of the icon supposing it's in the assets/icons folder. this is due to Vite limitainons
      return new URL(`../assets/icons/${this.name}.svg`, import.meta.url).href;
    }
  }
};
</script>

<template>
  <span class="app-icon" :class="type + '-icon'">
    <ion-icon v-if="type === 'font'" :class="name" :name="name"></ion-icon>
    <img v-if="type === 'img'" :src="imageSrc" />
    <svg
      v-if="type === 'svg'"
      v-html="svg.content"
      xmlns="http://www.w3.org/2000/svg"
      :width="width || svg.width"
      :height="height || svg.height"
      :viewBox="svg.viewBox"
    />
  </span>
</template>

<style lang="scss" scoped>
.app-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;

  span {
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
